jQuery(($) => {
  var events = [];
  $('[data-toggle]').each(function() {
    var $el = $(this);

    // Determine what events to listen to
    $el.data('toggle').split(',').forEach(function (event) {
      if(event.length === 0) return;
      if (events.indexOf(event) === -1) {
        events.push(event);
      }
    });
  });

  events.forEach(function (event) {
    $('body').on(event, '[data-toggle*="' + event + '"]', function (e) {
      e.preventDefault();

      var $this = $(this);
      var targetSelector = $this.data('target');
      var $target = targetSelector ? $(targetSelector) : $this;
      $target.toggleClass('is-opened');
      $target.attr('data-openable', '');

      if($target.hasClass('is-opened')) {
        $target.find('[data-focus]').focus();

        // If the target is exclusive, close all other exclusive collapsables
        if($target.is('[data-exclusive]')) {
          $('.is-opened[data-exclusive]').not($target).removeClass('is-opened');
        }
      }
    });
  });

  // Click outside
  $(document).on('click', function (e) {
    var target = $(e.target);

    if (!target.parents('.c-page__mobile-header').length
    && !target.parents('.c-page__search').length
    && !target.is('[data-toggle]')) {
      $('.is-opened[data-openable]').removeClass('is-opened');
    }
  });
});
